<template>
  <div class="md:h-screen flex flex-col-reverse md:flex-row">
    <div class="bg-gray-800 h-screen flex flex-col justify-center w-full">
      <h3 class="font-bold text-4xl left-header text-yellow-400">Contact Me</h3>
      <div class="flex mx-auto justify-between mt-10">
        <a href="mailto:peter082796@email.com">
          <img :src="require('@/assets/gmail.svg')" class="icon" />
        </a>
        <a href="https://github.com/peter2796b" target="_blank">
          <img :src="require('@/assets/github.svg')" class="icon" />
        </a>
        <a href="https://www.instagram.com/_peter_braganza_/" target="_blank">
          <img :src="require('@/assets/instagram.svg')" class="icon" />
        </a>
        <a
          href="https://www.linkedin.com/in/peter-braganza-2a5490155/"
          target="_blank"
        >
          <img :src="require('@/assets/linkedIn.svg')" class="icon" />
        </a>
      </div>
      <navigation :primary="'light'" class="md:mt-64" />
    </div>
  </div>
</template>
<script>
import Navigation from "./Navigation";

export default {
  components: {
    Navigation,
  },
};
</script>
<style lang="scss" >
@import url("https://fonts.googleapis.com/css2?family=Piedra&display=swap");
.left-header {
  font-family: "Piedra", cursive;
  letter-spacing: 5px;
  word-spacing: 10px;
}
.icon {
  width: 35px !important;
  height: 35px !important;
  margin-right: 25px !important;
  transition: all ease-in-out 0.3s;
  cursor: pointer;
  &:hover {
    width: 37px !important;
    height: 37px !important;
  }
}
</style>
